import nlnAxios from "../../../api/nlnAxios";


//Get recent internal resources by category

const getRecentInternal = async () => {

    const config = {
        headers: {
            // Authorization: `Bearer ${token}`
            Authorization: `Bearer `
    }
}

    const response = await nlnAxios.get("/library/public/resources/?resourceCategoryId=cccf126a-cb23-4f77-9afe-1c198624f80d" );

    return response.data;
}


const getRecentNigeriana = async () => {

    const config = {
        headers: {
            // Authorization: `Bearer ${token}`
            Authorization: `Bearer `
    }
}

    const response = await nlnAxios.get("/library/public/resources/?resourceType=internal&recentlyCreated=true" );

    return response.data;
}


const getRecentExternal = async () => {

    const config = {
        headers: {
            // Authorization: `Bearer ${token}`
            Authorization: `Bearer `
    }
}

    const response = await nlnAxios.get("/library/public/resources/?resourceType=external&recentlyCreated=true" );

    return response.data;
}

// getExternalCategory
const getExternalCategory = async () => {

    const config = {
        headers: {
            // Authorization: `Bearer ${token}`
            Authorization: `Bearer `
    }
}

    const response = await nlnAxios.get("/library/public/resources/categories/?resourceType=external" );

    return response.data;
}



const publicService = {
    getRecentInternal,
    getRecentNigeriana,
    getRecentExternal,
    getExternalCategory
    
}

export default publicService;